import { SectionsShowcaseClient } from "./SectionsShowcaseClient";

export default function SectionsPage() {
  return <SectionsShowcaseClient />;
}
